<div class="input-group">
  <button (click)="decreaseOne()" type="button">
    <i class="fa-solid fa-minus"></i>
  </button>
  <div *ngIf="prefix" class="prefix">
    <span class="text-muted">{{ prefix }}</span>
  </div>
  <input [(ngModel)]="value" (input)="onInputChange($event)" [ngClass]="{ 'has-prefix': prefix }" type="number" class="number-input"  />
  <button (click)="increaseOne()" type="button">
    <i class="fa-solid fa-plus"></i>
  </button>
</div>
